import axios, { AxiosInstance } from 'axios';

export class BaseInternalApi {
  private httpClient: AxiosInstance | undefined;
  protected accessToken!: string;

  constructor() {}

  protected getHttpClient() {
    return this.httpClient ?? this.setHttpClient();
  }

  public setAccessToken(accessToken: string): void {
    this.accessToken = accessToken;
  }

  private setHttpClient(): AxiosInstance {
    this.httpClient = axios.create({
      withCredentials: true,
      headers: {
        Authorization: this.accessToken,
      },
    });

    return this.httpClient;
  }
}
